import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const UnidadeNegocioRepository = createRepository({
  path: 'unidade-negocios',
  restApi,
  queryTransform: {
    descricao: query.ilike('descricao'),
    ...paginate
  }
})
export default UnidadeNegocioRepository
